<template>
  <section id="location" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">房源概况</div>
      </a-space>
    </div>

    <a-descriptions bordered class="desc-block">

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">租赁面积（平方米）</span>
        </template>
        {{ houseBaseInfo.leaseArea }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">装修现状</span>
        </template>
        {{
          intentLeaseInfo.decorateStatus == 1
            ? "精装"
            : intentLeaseInfo.decorateStatus == 2
            ? "毛坯"
            : intentLeaseInfo.decorateStatus == 3
            ? "简装"
            : intentLeaseInfo.decorateStatus == 4
            ? "拎包入住"
            : ""
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">是否接受分割出租</span>
        </template>
        {{
          intentLeaseInfo.acceptSplitRent  == 1 ? "是" : "否"
        }}
      </a-descriptions-item>

            <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">物业管理费</span>
        </template>
        {{
          intentLeaseInfo.hasPropertyManagementFee == 1
            ? "有物业管理费用，" +
              (intentLeaseInfo.propertyManagementFeeWay == 1
                ? "由承租方直接与物业结算"
                : intentLeaseInfo.propertyManagementFeeWay == 2
                ? "其他-" + (intentLeaseInfo.propertyManagementFeeWayDesc || "")
                : "") +
              "，物业管理费用金额：" +
              (intentLeaseInfo.propertyManagementFee || "") +
              (intentLeaseInfo.propertyManagementFeeUnit == 1
                ? "元/天/平方米"
                : intentLeaseInfo.propertyManagementFeeUnit == 2
                ? "元/月/平方米"
                : "")
            : "无物业管理费用"
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">是否可转租</span>
        </template>
        {{
          intentLeaseInfo.sublease == 1
            ? "可转租" +
              (intentLeaseInfo.subleaseDesc ? "：" + intentLeaseInfo.subleaseDesc : "")
            : "不可转租"
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">是否允许装修改造</span>
        </template>
          {{ intentLeaseInfo.allowRemodeling == 1 ? "是" : "否" }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">装修改造说明</span>
        </template>
        {{
          intentLeaseInfo.remodelingDesc}}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">是否有停车位</span>
        </template>
          {{
          intentLeaseInfo.parkingSpaceAvailable == 1
            ? intentLeaseInfo.numberParkingSpaces
              ? intentLeaseInfo.numberParkingSpaces + "个"
              : ""
            : "无"
        }}
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">项目业态</span>
        </template>
        <div>
          {{
            Array.isArray(houseBaseInfo.leaseUseType)
              ? houseBaseInfo.leaseUseType
                  .map((v) =>
                    v == 1
                      ? "商业"
                      : v == 2
                      ? "楼宇办公"
                      : v == 8
                      ? "园区"
                      : v == 16
                      ? "仓储"
                      : v == 32
                      ? "厂房"
                      : v == 64
                      ? "酒店"
                      : v == 256
                      ? "住宅"
                      : v == 512
                      ? "公寓"
                      : v == 1024
                      ? "工业"
                      : v == 2048
                      ? "农用"
                      : v == 4096
                      ? "市政配套"
                      : v == 8192
                      ? "场地"
                      : v == 16384
                      ? "其他"
                      : ""
                  )
                  .filter(Boolean)
                  .join("、")
              : ""
          }}
        </div>
        <div>
          风险提示：证载用途与租赁用途不一致，承租方承租后如需办理营业执照等事项，相应风险需自行承担
        </div>
      </a-descriptions-item>

      <a-descriptions-item :span="4">
        <template slot="label">
          <span class="desc-label-text">业态要求</span>
        </template>
          <div>
          {{ intentLeaseInfo.formatRequirements }}
        </div>

      </a-descriptions-item>
    </a-descriptions>
  </section>
</template>

<script>
export default {
  props: {
    intentLeaseInfo: {
      type: Object,
      default: () => null,
    },
    houseBaseInfo: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}

.desc-block /deep/ .ant-descriptions-item-content {
  width: 75%;
  background: white;
}
</style>